import { dropBoolean, dropTipoConta } from 'utils/drops';

const getContasFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'conta', label: 'Conta', initial: true },
  { name: 'descricao', label: 'Descrição' },
  {
    name: 'tipo',
    label: 'Tipo',
    type: 'select',
    options: dropTipoConta,
    multiple: true,
  },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getContasFilterFields;
